import { cn } from '../../../lib/cn';
import { TICKET_STATUS_LABELS, type TicketStatus } from '../tickets.schema';

const STATUS_CLASSES: Record<TicketStatus, string> = {
    open: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200',
    in_progress: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200',
    done: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200',
};

const STATUS_DOTS: Record<TicketStatus, string> = {
    open: 'bg-blue-500',
    in_progress: 'bg-amber-500',
    done: 'bg-emerald-500',
};

const SIZES = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
} as const;

export function TicketStatusBadge({
    status,
    size = 'sm',
    className,
}: {
    status: TicketStatus;
    size?: keyof typeof SIZES;
    className?: string;
}) {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full font-semibold ring-1 ring-inset ring-black/5 dark:ring-white/10',
                SIZES[size],
                STATUS_CLASSES[status],
                className,
            )}
        >
            <span aria-hidden="true" className={cn('h-2 w-2 rounded-full', STATUS_DOTS[status])} />
            {TICKET_STATUS_LABELS[status]}
        </span>
    );
}
